import { CollapsiblePositionBaseValue } from '@addins/core/singlecallcard/schema/collapsible-position-base-value';

export enum ParticularsPosition {
  CPersonRegular = CollapsiblePositionBaseValue.Particulars + 10,
  CPersonPce = CollapsiblePositionBaseValue.Particulars + 20,
  CVehicle = CollapsiblePositionBaseValue.Particulars + 30,
  CAnimal = CollapsiblePositionBaseValue.Particulars + 40,
  CObject = CollapsiblePositionBaseValue.Particulars + 50
}
